const API = {
    login:{
        register:'/api/stuTmp/register',                                            //注册
        webLogin:'/api/stu/login',                                                  //登录
        code:'/api/kaptcha/code',                                                   //随机数验证码
        allEnt:'/api/ent/all',                                                      //获取所有企业
        changePassword: '/api/stu/updatePassword',                                  //修改密码
        webLogout: '/api/stu/logout',                                               //web端退出登录
    },
    index:{
        allChannel:'/api/channel/all',                                              //首页获取所有的课程频道
        banner:'/api/banner/all',                                                   //首页banner图
        searchList:'/api/course/searchList',                                        //首页搜索课程
        latest:'/api/course/latest',                                                //获取最新的课程
        recommendList:'/api/course/recommendList',                                  //获取推荐的课程
        listByHigh:'/api/courseEvaluate/listByHigh',                                //首页查看精彩评价
        listByCourse:'/api/courseEvaluate/listByCourse',                            //某个课程下的评价记录列表（分页）
        totalByCourse:'/api/courseEvaluate/totalByCourse',                          //获取课程的评价统计结果
        addEvaluate:'/api/courseEvaluate/add',                                      //学员提交课程评价
        latestGift:'/api/gift/latest',                                              //获取最新的礼品
    },
    course:{
        courseInfo:'/api/course/info',                                              //获取课程详情
        listByCategory:'/api/course/listByCategory',                                //查询指定频道以及分类下的所有课程
        categoryAll:'/api/category/all',                                            //查看所有的课程分类（某个频道下的）
    },
    gift: {
        giftInfo:'/api/gift/info',                                                  //获取礼品详情
        listByCategory:'/api/gift/listByCategory',                                  //查询指定频道以及分类下的所有礼品
        categoryAll:'/api/giftCategory/all',                                        //查看所有的礼品分类（某个频道下的）
        listByGift:'/api/giftEvaluate/listByGift',                                  //某个礼品下的评价记录列表（分页）
        totalByGift:'/api/giftEvaluate/totalByGift',                                //获取礼品的评价统计结果
        allExchange:'/api/stu/allExchange',                                         //获取指定学员所有订单
        createOrder:'/api/stu/createExchange',                                      //学员创建订单
        cancelOrder:'/api/stu/cancelExchange',                                      //学员取消订单
        orderInfo:'/api/stu/exchangeInfo',                                          //学员查看订单信息
        integralPay: '/api/studentIntegral/payGift',                                //学员支付订单
        integralPage: '/api/studentIntegral/page',                                  //学员积分明细
        addEvaluate:'/api/giftEvaluate/add',                                        //学员提交课程评价
    },
    order:{
        zeroPay:'/api/wx/zeroPay',                                                  //微信支付-订单金额为0时支付接口
        jspay:'/api/wx/nativePay',                                                  //微信支付-微信手机端支付，不为0的支付
        studentIntegral:'/api/studentIntegral/pay',                                 //学员使用积分支付
        payGetStatus:'/api/stu/hasPayByCode',                                       //获取订单状态
        createOrder:'/api/stu/createOrder',                                         //学员创建订单
        cancelOrder:'/api/stu/cancelOrder',                                         //学员取消订单               ---------1  
        allOrder:'/api/stu/allOrder',                                               //获取指定学员所有订单       ---------1  
        orderInfo:'/api/stu/orderInfo',                                             //学员查看订单信息           ---------1
    },
    purchase:{
        hasBuyCourses:'/api/stu/hasBuyCourses',                                     //获取指定学员所有已购买课程
        courseInfo:'/api/stu/courseInfo',                                           //获取指定学员已购买的课程详情（包含学习信息, 考试信息）--章节
        videoInfo:'/api/stu/videoInfo',                                             //学员查看视频详情
        saveStudyRecord:'/api/stu/saveStudyRecord',                                 //记录学时（一分钟一次）
    },
    exam:{
        allCourseTest:'/api/stu/allCourseTest',                                     //学员获取所有考试记录--- 列表  
        startMockTest:'/api/stu/startMockTest',                                     //学员开始模拟考试（针对不需要领取证书的培训课程）--- 题目详情:不需要领取证书
        startCourseTest:'/api/stu/startCourseTest',                                 //学员开始考试 - 抽取题目组成试卷 - 返回题目列表（包含题目选项及正确答案）---题目详情:需要领取证书
        submitTest:'/api/stu/submitTest',                                           //学员交卷
        courseTestInfo:'/api/stu/courseTestInfo',                                   //学员查看考试记录详情---解析
    },
    cert:{
        delCert:'/api/stu/delCert',                                                 //删除证书 -- 生成证书用
        delInitCert:'/api/stu/delInitCert',                                         //删除注册证书记录 -- 个人信息用
        addInitCert:'/api/stu/addInitCert',                                         //新增注册证书记录
        allCert:'/api/stu/allCert',                                                 //查看已经领取的证书记录  -我的证书
        createCert:'/api/stu/createCert',                                           //学员领取证书 --1
        certByCourse:'/api/stu/certByCourse',                                       //学员查看指定课程的所有已生成的证书 -- 1
    },
    comm:{
        checkFace:'/api/stu/checkFace',                                             //学员人脸比对
        updatePassword:'/api/stu/updatePassword',                                   //学员修改密码
        getAll:'/api/certType/getAll',                                              //获取所有的证书类型
        info:'/api/stu/info',                                                       //获取学员详情 （包含注册证书记录）
        updateInfo:'/api/stu/updateInfo',                                           //修改基本信息
        changeHeaderImage:'/api/stu/changeHeaderImage',                             //修改头像
        updateFace:'/api/stu/updateFace',                                           //修改免冠照
    },
    headerManage:{                                                                  //抬头列表
        fpHeaderList:'/api/fpHeader/list',
        fpHeaderPage:'/api/fpHeader/page',
        fpHeaderOne:'/api/fpHeader/one',
        fpHeaderAdd:'/api/fpHeader/add',
        fpHeaderEdit:'/api/fpHeader/edit',
        fpHeaderDel:'/api/fpHeader/del'
    },
    invoices:{                                                                      //发票管理
        page:'/api/fpApply/page',
        one:'/api/fpApply/one',
        add:'/api/fpApply/add',
        edit:'/api/fpApply/edit',
        del:'/api/fpApply/del' 
    }

}
export default API




// WEBPACK FOOTER //
// ./src/api/api.js